export default __webpack_public_path__ + "static/media/122.01d0e130.png";